import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcToLocal'
})
export class UtcToLocalPipe implements PipeTransform {

  transform(utcDate: Date | string): Date {
    if (!utcDate) {
      return new Date();
    }

    // Create a Date object from the UTC datetime
    const utcDateTime = new Date(utcDate);
    
    // Convert to browser's local timezone by applying the timezone offset
    const localDateTime = new Date(utcDateTime.getTime() - (utcDateTime.getTimezoneOffset() * 60 * 1000));
    
    return localDateTime;
  }
}
